var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.events)?_c('events-list',{attrs:{"is-loading":_vm.isLoading,"payment-notifications":_vm.events,"img-no":_vm.imgNo}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }